import { render } from "./distributeView.vue?vue&type=template&id=366401bb&scoped=true"
import script from "./distributeView.vue?vue&type=script&lang=js"
export * from "./distributeView.vue?vue&type=script&lang=js"

import "./distributeView.vue?vue&type=style&index=0&id=366401bb&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366401bb"]])

export default __exports__